import { render } from "./Univ-Details.vue?vue&type=template&id=14f3521b&scoped=true"
import script from "./Univ-Details.vue?vue&type=script&lang=js"
export * from "./Univ-Details.vue?vue&type=script&lang=js"

import "./Univ-Details.vue?vue&type=style&index=0&id=14f3521b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-14f3521b"

export default script